// extracted by mini-css-extract-plugin
export default {"dialogContent":"forceAppUpdatePopup_dialogContent__wurSu"};